// extracted by mini-css-extract-plugin
export default {"manual-button":"manual-button_manual-button__e3j4U","dx-state-disabled":"manual-button_dx-state-disabled__akfwH","dx-icon":"manual-button_dx-icon__nNM6U"};